import { QuoteEventType } from '@features/invoices/enums/quoteEventType'

import { useQuote } from '../../../contexts/quoteContext'

const allValidStatusEvents: string[] = Object.values(QuoteEventType)

export const useSupportedQuoteStatusEvents = () => {
  const { quote, isLoading } = useQuote()
  const statusEvents = quote?.status?.events || []

  const supportedStatusEvents = statusEvents.filter((event) => allValidStatusEvents.includes(event.eventType))

  return { isLoading, statusEvents: supportedStatusEvents }
}
